export default __webpack_public_path__ + "static/media/227.3c1a5bd5.jpg";